import { Camera, Trash } from "lucide-react";
import { useEffect, useState } from "react";

import ParagraphTag from "../../../reusebale/Paragraph";
import ButtonTag from "../../../reusebale/button";
import LabelTag from "../../../reusebale/label";
import MyLoader from "../../../reusebale/myLoader";

import { useDispatch, useSelector } from "react-redux";
import * as PropertyAction from "../../../../store/actions/property/PropertyAction";

import BaseUrl from "../../../../constants/BaseUrl";
import { ShowError, ShowSuccess } from "../../../../utils/ToasFunction";

const Address = () => {
  const dispatch = useDispatch();
  const { createNewPropertyBody } = useSelector((state) => state.property);
  const { allCitiesAndStates } = useSelector((state) => state.data);

  const [formData, setFormData] = useState({
    propertyName: "",
    compleAddress: "",
    streetOne: "",
    streetTwo: "",
    city: "",
    state: "",
    country: "United State",
    zipCode: "",
    langitude: "28.9900",
    latitude: "29.4900",
    thumbNailImage: null,
    imagesList: [],
    sitePlan: null,
    thumbnailLoader: false,
    imagesLoader: false,
    sitePlanLoader: false,
  });

  const [cities, setCities] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  useEffect(() => {
    // Log the data when component mounts or `allCitiesAndStates` changes
    console.log("Cities and States Data:", allCitiesAndStates);
  }, [allCitiesAndStates]);

  const preeStateSelect = (value) => {
    const state = value;
    setSelectedState(state);
    setFormData({
      ...formData,
      state: value,
    });

    // Find the selected state's cities and set in the state
    const stateData = allCitiesAndStates.find((item) => item.state === state);
    setCities(stateData ? stateData.cities : []); // Update cities
  };
  useEffect(() => {
    if (createNewPropertyBody.completeAddress) {
      preeStateSelect(createNewPropertyBody.state);
      setFormData({
        ...formData,
        propertyName: createNewPropertyBody.propertyName,
        compleAddress: createNewPropertyBody.completeAddress,
        streetOne: createNewPropertyBody.completeAddress,
        streetTwo: createNewPropertyBody.streetTwo,
        state: createNewPropertyBody.state,
        country: createNewPropertyBody.country,
        zipCode: createNewPropertyBody.zipCode,
        langitude: createNewPropertyBody.langitude,
        latitude: createNewPropertyBody.latitude,
        thumbNailImage: createNewPropertyBody.thumbnailImage,
        imagesList: createNewPropertyBody.images,
        sitePlan: createNewPropertyBody.sitePlan,
        city: createNewPropertyBody.city,
      });
    }
  }, [createNewPropertyBody]);

  useEffect(() => {
    if (createNewPropertyBody.completeAddress) {
      // preeStateSelect(createNewPropertyBody.state)
      // setFormData({
      //   ...formData,
      //   city: createNewPropertyBody.city,
      // });
    }
  }, []);

  const handleStateChange = (e) => {
    const state = e.target.value;
    setSelectedState(state);
    setFormData({
      ...formData,
      state: e.target.value,
    });

    // Find the selected state's cities and set in the state
    const stateData = allCitiesAndStates.find((item) => item.state === state);
    setCities(stateData ? stateData.cities : []); // Update cities
  };

  const UploadImagesToServer = (imagesList) => {
    setFormData((prevData) => ({
      ...prevData,
      imagesLoader: true,
    }));

    const formdata = new FormData();

    // Append each image to the FormData object
    imagesList.forEach((image) => {
      formdata.append("images", image); // "images" must match backend's expected key
    });

    const requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
    };

    fetch(
      `${BaseUrl}api/propertyImage/cloudinary-upload-multiple`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result?.results && Array.isArray(result.results)) {
          const uploadedImages = result.results.map((img) => ({
            url: img.secure_url,
            public_id: img.public_id,
            original_filename: img.original_filename,
          }));

          setFormData((prevData) => ({
            ...prevData,
            imagesLoader: false,
            imagesList: [...prevData.imagesList, ...uploadedImages],
          }));

          ShowSuccess("Images uploaded successfully");
        } else {
          setFormData((prevData) => ({
            ...prevData,
            imagesLoader: false,
          }));
          ShowError(
            "Oops! Something went wrong. Please upload JPEG or PNG images up to 2MB"
          );
        }
      })
      .catch((error) => {
        console.error("Upload error:", error);
        setFormData((prevData) => ({
          ...prevData,
          imagesLoader: false,
        }));
        ShowError(
          "Oops! Something went wrong. Please upload JPEG or PNG images up to 2MB"
        );
      });
  };

  // Handle image selection
  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    const currentImageCount = formData.imagesList.length;
    const newImageCount = files.length;

    // Check if adding new images would exceed the limit of 4
    if (currentImageCount + newImageCount > 4) {
      ShowError("Maximum 4 cover images can be uploaded");
      return;
    }

    UploadImagesToServer(files);
  };

  const ThumbNailImage = (imageData) => {
    setFormData({
      ...formData,
      thumbnailLoader: true,
    });

    const formdata = new FormData();
    formdata.append("image", imageData);

    const requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
    };

    fetch(`${BaseUrl}api/propertyImage/cloudinary-upload`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result?.cloudinary?.secure_url) {
          const thumbNailImage = {
            url: result.cloudinary.secure_url,
            public_id: result.cloudinary.public_id,
            original_filename: result.cloudinary.original_filename,
          };
          setFormData({
            ...formData,
            thumbnailLoader: false,
            thumbNailImage: thumbNailImage,
          });
        } else {
          ShowError(
            "Oops! Something went wrong. Please upload an image in JPEG or PNG format with a maximum size of 2MB"
          );
        }
      })
      .catch((error) => {
        setFormData({
          ...formData,
          thumbnailLoader: false,
        });
        ShowError(
          "Oops! Something went wrong. Please upload an image in JPEG or PNG format with a maximum size of 2MB"
        );
      });
  };

  const UploadSitePlan = (imageData) => {
    setFormData({
      ...formData,
      sitePlanLoader: true,
    });

    const formdata = new FormData();
    formdata.append("image", imageData);

    const requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
    };

    fetch(`${BaseUrl}api/propertyImage/cloudinary-upload`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result?.cloudinary?.secure_url) {
          const sitePlanImage = {
            url: result.cloudinary.secure_url,
            public_id: result.cloudinary.public_id,
            original_filename: result.cloudinary.original_filename,
          };
          setFormData({
            ...formData,
            sitePlanLoader: false,
            sitePlan: sitePlanImage,
          });
          ShowSuccess("Site plan uploaded successfully");
        } else {
          setFormData({
            ...formData,
            sitePlanLoader: false,
          });
          ShowError(
            "Oops! Something went wrong. Please upload an image in JPEG or PNG format with a maximum size of 2MB"
          );
        }
      })
      .catch((error) => {
        setFormData({
          ...formData,
          sitePlanLoader: false,
        });
        ShowError(
          "Oops! Something went wrong. Please upload an image in JPEG or PNG format with a maximum size of 2MB"
        );
      });
  };

  const deleteFromCloudinary = async (publicId) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    // 🔑 Add token if required
    // myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);

    const raw = JSON.stringify({ publicId });

    const requestOptions = {
      method: "DELETE",
      headers: myHeaders,
      body: raw,
    };

    try {
      const response = await fetch(
        `${BaseUrl}api/uploads/cloudinary-delete`,
        requestOptions
      );
      const result = await response.json();

      if (result?.result === "ok") {
        ShowSuccess("Image deleted successfully.");
        return true;
      } else {
        ShowError("Oops! Something went wrong while deleting.");
        return false;
      }
    } catch (error) {
      console.error("Cloudinary delete error:", error);
      ShowError("Oops! Something went wrong while deleting.");
      return false;
    }
  };

  // Trigger file input on icon click
  const handleIconClick = () => {
    document.getElementById("fileInput").click();
  };

  const handleIconClickThumbnail = () => {
    document.getElementById("fileInput2").click();
  };

  const handleIconClickSitePlan = () => {
    document.getElementById("fileInputSitePlan").click();
  };

  const NextHandler = (e) => {
    e.preventDefault();
    if (formData.propertyName === "") {
      ShowError("Property name cannot be empty");
    } else if (formData.compleAddress === "") {
      ShowError("Address cannot be empty");
    } else if (!formData.thumbNailImage) {
      ShowError("Property image is required");
    } else {
      dispatch(PropertyAction.ChangePropertyCreateSteps(3));
      dispatch(PropertyAction.CreatePropertyStepTwoAction(formData));
    }
  };

  const BackHandler = (e) => {
    e.preventDefault();
    dispatch(PropertyAction.ChangePropertyCreateSteps(1));
  };

  const DeleteThumbnailImage = async (image) => {
    const success = await deleteFromCloudinary(image.public_id);

    if (success) {
      setFormData({
        ...formData,
        thumbNailImage: null,
      });
    }
  };

  const DeleteSitePlan = async (image) => {
    const success = await deleteFromCloudinary(image.public_id);

    if (success) {
      setFormData({
        ...formData,
        sitePlan: null,
      });
    }
  };

  const DeleteImageHandler = async (image) => {
    const success = await deleteFromCloudinary(image.public_id);

    if (success) {
      const updatedList = formData.imagesList.filter(
        (i) => i.public_id !== image.public_id
      );
      setFormData({
        ...formData,
        imagesList: updatedList,
      });
    }
  };

  return (
    <div className="w-[70%] mx-auto h-full">
      <div className="text-center h-[10%]">
        <ParagraphTag
          content="Property Information"
          classes="text-darkColor font-popinsSemiBold text-base 2xl:text-lg"
        />
        <div>
          <ParagraphTag
            content="Complete address and other information"
            classes="text-[#686868] font-popinsRegular text-xs"
          />
        </div>
      </div>
      <form className="property-form overflow-y-scroll h-[80%] panelScroll px-1">
        <div>
          <LabelTag
            isStaric={true}
            name="Property Name"
            classes="!text-xs !font-popinsMedium"
          />
          <input
            value={formData.propertyName}
            onChange={(e) => {
              setFormData({
                ...formData,
                propertyName: e.target.value,
              });
            }}
            type="text"
            placeholder="e.g. XYZ Business Heights"
            className="w-full mt-1 text-sm bg-bgColor border border-gray-300 shadow-none font-popinsRegular px-3 py-2.5 rounded-md text-darkColor placeholder:text-gray-500 focus:outline-none focus:border-themeColor"
          />
        </div>
        <div className="mt-3">
          <LabelTag
            isStaric={true}
            name="Complete Address"
            classes="!text-xs !font-popinsMedium"
          />
          <textarea
            value={formData.compleAddress}
            onChange={(e) => {
              setFormData({
                ...formData,
                compleAddress: e.target.value,
              });
            }}
            rows={2}
            placeholder="e.g. 6115 Camp Bowie Boulevard, Suite 100, Fort Worth, Texas 76026"
            className="w-full mt-1 text-sm bg-bgColor border border-gray-300 shadow-none font-popinsRegular px-3 py-2.5 rounded-md text-darkColor placeholder:text-gray-500 focus:outline-none focus:border-themeColor resize-none"
          />
        </div>
        <div className="mt-4 flex gap-6">
          {/* Property Image (Thumbnail) */}
          <div className="flex-1">
            <LabelTag
              isStaric={true}
              name="Property Image"
              classes="!text-xs !font-popinsMedium"
            />
            <div className="mt-2 h-[140px]">
              {formData.thumbnailLoader ? (
                <div className="flex justify-center items-center h-[140px]">
                  <MyLoader />
                </div>
              ) : (
                <div
                  className={`${
                    formData?.thumbNailImage?.url
                      ? ""
                      : "border-dashed border-2 border-gray-300 hover:border-themeColor"
                  } flex flex-col items-center justify-center w-full h-full bg-bgColor rounded-md cursor-pointer transition-colors`}
                >
                  {formData?.thumbNailImage?.url ? (
                    <div className="relative w-full h-full">
                      <img
                        src={formData?.thumbNailImage?.url}
                        alt=""
                        className="w-full h-[140px] object-cover rounded-md"
                      />
                      <div className="absolute top-1 right-1">
                        <div
                          onClick={() => {
                            DeleteThumbnailImage(formData?.thumbNailImage);
                          }}
                          className="bg-dangerColor rounded-md cursor-pointer w-7 h-7 flex justify-center items-center"
                        >
                          <Trash color="#FFFF" size={18} />
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div
                      className="flex flex-col justify-center items-center h-full"
                      onClick={handleIconClickThumbnail}
                    >
                      <Camera
                        className="text-darkColor/40"
                        size={35}
                        strokeWidth={1.5}
                      />
                      <ParagraphTag
                        content="Upload Property Image"
                        classes="pt-1 text-darkColor/50 font-popinsRegular text-xs"
                      />
                      <ParagraphTag
                        content="JPEG or PNG, max 2MB"
                        classes="text-darkColor/30 font-popinsRegular text-[10px]"
                      />
                      <input
                        type="file"
                        id="fileInput2"
                        accept="image/*"
                        onChange={(event) => {
                          const file = event.target.files[0];
                          if (file) {
                            ThumbNailImage(file);
                          }
                        }}
                        className="hidden"
                      />
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>

          {/* Site Plan (Optional) */}
          <div className="flex-1">
            <LabelTag
              isStaric={false}
              name="Site Plan (Optional)"
              classes="!text-xs !font-popinsMedium"
            />
            <div className="mt-2 h-[140px]">
              {formData.sitePlanLoader ? (
                <div className="flex justify-center items-center h-[140px]">
                  <MyLoader />
                </div>
              ) : (
                <div
                  className={`${
                    formData?.sitePlan?.url
                      ? ""
                      : "border-dashed border-2 border-gray-300 hover:border-themeColor"
                  } flex flex-col items-center justify-center w-full h-full bg-bgColor rounded-md cursor-pointer transition-colors`}
                >
                  {formData?.sitePlan?.url ? (
                    <div className="relative w-full h-full">
                      <img
                        src={formData?.sitePlan?.url}
                        alt="Site Plan"
                        className="w-full h-full object-cover rounded-md"
                      />
                      <div className="absolute top-1 right-1">
                        <div
                          onClick={() => {
                            DeleteSitePlan(formData?.sitePlan);
                          }}
                          className="bg-dangerColor rounded-md cursor-pointer w-7 h-7 flex justify-center items-center"
                        >
                          <Trash color="#FFFF" size={18} />
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div
                      className="flex flex-col justify-center items-center h-full"
                      onClick={handleIconClickSitePlan}
                    >
                      <Camera
                        className="text-darkColor/40"
                        size={35}
                        strokeWidth={1.5}
                      />
                      <ParagraphTag
                        content="Upload Site Plan"
                        classes="pt-1 text-darkColor/50 font-popinsRegular text-xs"
                      />
                      <ParagraphTag
                        content="JPEG or PNG, max 2MB"
                        classes="text-darkColor/30 font-popinsRegular text-[10px]"
                      />
                      <input
                        type="file"
                        id="fileInputSitePlan"
                        accept="image/*"
                        onChange={(event) => {
                          const file = event.target.files[0];
                          if (file) {
                            UploadSitePlan(file);
                          }
                        }}
                        className="hidden"
                      />
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>

        {/* <div className="mt-4">
          <ImageTag
            classes="rounded-lg"
            path={"/assets/daashboard/map-overview.png"}
            altText="logo"
          />
        </div> */}
      </form>
      <div className="h-[10%] flex justify-center items-center">
        <div className="w-[40%] mx-auto flex gap-4">
          <ButtonTag
            onSubmit={BackHandler}
            name="Back"
            classes="text-base text-center bg-gray-500 text-white"
          />
          <ButtonTag
            onSubmit={NextHandler}
            name="Next"
            classes="text-base text-center bg-themeColor text-white"
          />
        </div>
      </div>
    </div>
  );
};

export default Address;
